module.exports = new __parcel__URL__("67332_sq.668b3624.jpg").toString();